//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"LineardimTextureSpaceScaleU",0,"Expression",0],[1,"LineardimTextureSpaceScaleV",0,"Expression",0],[1,"LineardimTextureSpaceScaleW",0,"Expression",0],[0,"MaterialName",1,0],[0,"PointTextureSpaceOrigin",1,"Point",0],[0,"TextureSpace",1,0],[0,"TextureSpaceAnchor",1,0],[0,"TextureSpaceCoordinateSpace",1,0],[0,"TextureSpaceFlipU",1,0],[0,"TextureSpaceFlipV",1,0],[0,"TextureSpaceOffsetU",1,0],[0,"TextureSpaceOffsetV",1,0],[0,"TextureSpaceRotationAngle",1,0],[0,"TextureSpaceUniformScale",1,0],[0,"VectorTextureSpaceNormal",1,"Direction",0],[0,"VectorTextureSpaceUp",1,"Direction",0]],[],[]];
SPLM.Display.VisualMaterialEditorTextureSpaceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.VisualMaterialEditorTextureSpaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.VisualMaterialEditorTextureSpaceBuilder.TextureSpaceType = Object.freeze({
    "Box" : "Box", "Planar" : "Planar", "Uv" : "Uv", "Spherical" : "Spherical", "Cylindrical" : "Cylindrical"});

SPLM.Display.VisualMaterialEditorTextureSpaceBuilder.CoordinateSystemType = Object.freeze({
    "RelativetoPart" : "RelativetoPart", "RelativetoWorld" : "RelativetoWorld"});

SPLM.Display.VisualMaterialEditorTextureSpaceBuilder.TextureSpaceAnchorType = Object.freeze({
    "BottomLeft" : "BottomLeft", "TopLeft" : "TopLeft", "Center" : "Center"});

export default SPLM;